/**
 * MotoRava bundle tiers: keeps the tier radios and the product form's
 * quantity input in sync. Picking a tier writes its quantity into the input;
 * typing a quantity selects the matching tier (or none).
 */
class MrBundleTiers extends HTMLElement {
  /** @type {AbortController | undefined} */
  #abort;

  connectedCallback() {
    this.#abort?.abort();
    this.#abort = new AbortController();
    const { signal } = this.#abort;

    this.addEventListener('change', this.#onTierChange, { signal });

    const input = this.#quantityInput();
    if (input) {
      input.addEventListener('input', () => this.#syncFromInput(), { signal });
      input.addEventListener('change', () => this.#syncFromInput(), { signal });
      this.#syncFromInput();
    }
  }

  disconnectedCallback() {
    this.#abort?.abort();
  }

  /** @returns {HTMLInputElement | null} */
  #quantityInput() {
    const scope = this.closest('.shopify-section') ?? document;
    return scope.querySelector('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]');
  }

  /** @param {Event} event */
  #onTierChange = (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;

    const input = this.#quantityInput();
    if (!input) return;

    const selector = input.closest('quantity-selector-component');
    if (selector && typeof selector.setValue === 'function') {
      selector.setValue(radio.value);
    } else {
      input.value = radio.value;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
  };

  #syncFromInput() {
    const input = this.#quantityInput();
    if (!input) return;
    for (const radio of this.querySelectorAll('input[type="radio"]')) {
      if (radio instanceof HTMLInputElement) radio.checked = radio.value === input.value;
    }
  }
}

if (!customElements.get('mr-bundle-tiers')) {
  customElements.define('mr-bundle-tiers', MrBundleTiers);
}
